export default __webpack_public_path__ + "static/media/tommie_drawing.5785af1d.jpg";